var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article"},[_vm._m(0),_c('div',{staticClass:"newsContent"},_vm._l((_vm.sortedList),function(ref){
var id = ref.id;
var name = ref.name;
var date = ref.date;
var img = ref.img;
var content = ref.content;
var moreInfo = ref.moreInfo;
var tag = ref.tag;
var tag2 = ref.tag2;
return (id===_vm.article_id)?_c('articleCard',{key:id,attrs:{"id":id,"article_title":name,"article_date":date,"article_img":img,"article_content":content,"article_moreInfo":moreInfo,"article_tag":tag,"article_tag2":tag2}}):_vm._e()}),1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("CONTENTS")])])}]

export { render, staticRenderFns }